import { FACILITY_FRAGMENT } from '@/entities/facility/@x/study';
import { gql } from '@apollo/client';
import INSURANCE_FRAGMENT from '../fragments/insuranceFragment';
import PHYSICIAN_FRAGMENT from '../fragments/physicianFragment';
import PATIENT_FRAGMENT from '../fragments/patientFragment';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import PATIENT_ONBOARDING_FRAGMENT from '../fragments/patientOnBoardingFragment';
import STUDY_SETTING_FRAGMENT from '../fragments/studySettingFragment';

const COPIED_STUDY_QUERY = gql`
  query copiedStudy($id: ID!) {
    study(id: $id) {
      id
      friendlyId
      onboarding {
        ...PatientOnBoardingFragment
      }
      studyType
      deviceType
      info {
        insurance {
          ...InsuranceFragment
        }
        interprettingPhysician {
          ...PhysicianFragment
        }
        patient {
          ...PatientFragment
        }
        diagnosis {
          ...DiagnosisFragment
        }
        referringPhysician {
          ...PhysicianFragment
        }
        clinicianInitials
        studySetting {
          ...StudySettingFragment
        }
      }
      facility {
        ...FacilityFragment
      }
      isTest
    }
  }

  ${PATIENT_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
  ${FACILITY_FRAGMENT}
  ${INSURANCE_FRAGMENT}
  ${PATIENT_ONBOARDING_FRAGMENT}
  ${PHYSICIAN_FRAGMENT}
  ${STUDY_SETTING_FRAGMENT}
`;

export default COPIED_STUDY_QUERY;
